/**
 * Antes medía el header y aplicaba top inline a ion-tabs.
 * Eso fallaba en producción (Ionic borraba el style a los ~1s).
 * El hueco lo resuelve CSS flex en App.vue — este composable queda
 * como no-op para no romper imports existentes.
 */
export function useTabsBelowHeader(
  _headerRef?: unknown,
  _tabsRef?: unknown,
  _isActive?: () => boolean,
  _layoutKey?: () => unknown,
): void {
  /* layout en App.vue: ion-tabs.galidancia-tabs-below-header → position:relative + flex */
}
